import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root container not found. Add <div id="root"></div> to index.html');
}

createRoot(container).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
